import { useState, useCallback } from 'react';

export const useCollapse = (initialCollapsed = false) => {
    const [collapsed, setCollapsed] = useState(initialCollapsed);
    const toggle = useCallback(() => setCollapsed((prev) => !prev), []);
    return [collapsed, toggle];
};
